import { LinearProgress, linearProgressClasses, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import { getStorageSize } from '../../../../utils/storage'
import { SidebarTooltip } from './SidebarTooltip'

type Props = {
    storageSizeMb?: number
    ragSizeMb?: number
}

const valuePostfix = { mb: 'Мб', gb: 'Гб' }

export const StorageProgressBar: FC<Props> = ({ disabled, storageSizeMb = 0, ragSizeMb = 0 }) => {
    const { breakpoints } = useTheme()
    const isMobile = useMediaQuery(breakpoints.down('sm'))

    const filledValue = getStorageSize(storageSizeMb, valuePostfix)
    const totalValue = getStorageSize(ragSizeMb, valuePostfix)

    const progressValue = (storageSizeMb / ragSizeMb) * 100

    return (
        <SidebarTooltip
            title={`Заполнено ${filledValue} из ${totalValue}`}
            placement={isMobile ? 'top-start' : 'right'}>
            <LinearProgress
                variant="determinate"
                value={progressValue}
                sx={{
                    opacity: disabled ? '0.3': '1',
                    width: '80px',
                    borderRadius: '100px',
                    backgroundColor: '#E7E8EE',
                    ml: 1,
                    mr: 1,

                    [`.${linearProgressClasses.bar}`]: {
                        borderRadius: '100px',
                        backgroundColor: progressValue >= 80 ? '#E82C1F' : '#006CFD',
                    },
                }}
            />
        </SidebarTooltip>
    )
}
